var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minus-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 9.16602H5.83333C5.3731 9.16602 5 9.53911 5 9.99935C5 10.4596 5.3731 10.8327 5.83333 10.8327H14.1667C14.6269 10.8327 15 10.4596 15 9.99935C15 9.53911 14.6269 9.16602 14.1667 9.16602Z",
    fill: "#4A5655"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusSmall);
export default __webpack_public_path__ + "static/media/minus-small.e5604f8176b517081ca0fa81d00847c9.svg";
export { ForwardRef as ReactComponent };